(ns app.front.view.group.admin.branding.email
  (:require [app.domain.file.model :as file-model]
            [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.file.upload :as upload]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.files :as files]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::editor :-> ::editor)

(rf/reg-sub ::value-in-editor
  :<- [::editor]
  (fn [editor [_ k]]
    (get editor k)))

(rf/reg-event-fx ::set-value-in-editor
  (fn [{:keys [db]} [_ k v]]
    {:db (assoc-in db [::editor k] v)}))

(rf/reg-event-db ::clear-editor
  (fn [db _]
    (dissoc db ::editor)))

(rf/reg-event-fx ::save-branding-attributes
  (fn [{{editor ::editor} :db} [_ group-id]]
    {:fx (concat
           (when-some [data (->> (dissoc editor :group/branding-email-logo)
                                 (p/remove-vals nil?)
                                 not-empty)]
             [[:comm/command {:command    :group/save-branding-attributes
                              :data       {:group-id group-id
                                           :data     data}
                              :notify     {:success :group.admin.branding/save-success}
                              :on-success [::save-branding-attributes.success]}]])
           (when-some [logo-data (:group/branding-email-logo editor)]
             [[:comm/command
               {:command    :group/set-branding-image
                :data       logo-data
                :notify     {:success :group.admin.branding/save-success}
                :on-success [::save-branding-attributes.success]}]]))}))

(rf/reg-event-fx ::save-branding-attributes.success
  (fn [{:keys [db]} [_ status response]]
    {:db       (dissoc db ::editor)
     :dispatch [::entities/apply-changes status response]}))

(rf/reg-event-fx ::reset-branding
  (fn [_ [_ group-id]]
    {:comm/command {:command    :group/delete-branding
                    :data       {:group-id group-id
                                 :category :email}
                    :notify     {:success :group.admin.branding/delete-success}
                    :on-success [::entities/apply-changes]}}))

(defn color-editor [tr k v]
  [ui/color-input {:label-text (tr [k])
                   :value      v
                   :on-change  #(>evt [::set-value-in-editor k (futil/tval %)])}])

(defn section [tr]
  (let [group               (<sub [::gas/group])
        color-attr          :group/branding-email-header-colour
        current-color-value (or (<sub [::value-in-editor color-attr])
                                (get group color-attr)
                                "#191147")]
    [:section
     [:div.flex.flex-col.gap-4
      [:div.flex
       [color-editor tr color-attr current-color-value]]
      [:div
       [ui/help
        (tr [:group.admin.branding/email-logo-limits])]]
      [:div.gap-4.flex.items-center
       [upload/upload-button "upload-logo-button"
        {:tr               tr
         :label-text       (tr [:group.admin.branding/upload-email-logo])
         :button-opts      {:kind :primary
                            :size :field}
         :attach-file-fn   (fn [file-id filename content-type md5]
                             (>evt [::set-value-in-editor
                                    :group/branding-email-logo
                                    {:group-id (:db/id group)
                                     :attr     :group/branding-email-logo
                                     :file-id  file-id
                                     :file     {:file/filename     filename
                                                :file/content-type content-type
                                                :file/category     :file.category/branding-logo
                                                :file/md5          md5}}]))
         :size-constraints {:bytes     (file-model/size-limits :file.category/branding-logo)
                            :width     1400
                            :height    600
                            :ratio-w-h 8
                            :ratio-h-w 1.25}
         :accept-types     [".png" ".jpg"]}]
       (when-let [filename (-> (<sub [::value-in-editor :group/branding-email-logo])
                               :file
                               :file/filename
                               (or (-> group
                                       :group/branding-email-logo
                                       :file/filename)))]
         [:div.font-bold filename])]
      (when-let [image (:group/branding-email-logo group)]
        [:div.flex.flex-col
         [:h3 (tr [:group.admin.branding/header-preview])]
         (when (<sub [::value-in-editor :group/branding-email-logo])
           [:div.mb-2 (tr [:group.admin.branding/preview-update-note])])
         [:div.flex.w-full.items-center.justify-center
          {:id    (:db/id image)
           :style {:background-color current-color-value
                   :height           "135px"
                   :max-width        "700px"}}
          [:img {:style {:max-height "80px"}
                 :src   (files/file-link (:db/id group) (:db/id image) false)}]]])
      (for-frag [k [:group/branding-email-closing-statement
                    :group/branding-email-disclaimer]]
        [:div
         [ui/text-area {:id         (name k)
                        :label-text (tr [k])
                        :value      (or (<sub [::value-in-editor k])
                                        (get group k))
                        :on-change  #(rf/dispatch-sync [::set-value-in-editor k (futil/tval %)])}]])
      [:div.flex.justify-between
       [:div
        (when (some #(get group %) group-model/email-branding-attributes)
          [ui/modal-confirmation-button
           {:id                  "reset-email-branding"
            :tr                  tr
            :on-yes-click        #(>evt [::reset-branding (:db/id group)])
            :trigger-button-text (tr [:group.admin.branding/reset-email-branding])
            :trigger-button-opts {:kind :danger}}
           (tr [:group.admin.branding/reset-email-branding-modal-text])])]
       (when (seq (<sub [::editor]))
         [ui-action-buttons/save-cancel-buttons
          {:on-cancel #(>evt [::clear-editor])
           :on-save   #(>evt [::save-branding-attributes (:db/id group)])
           :tr        tr}])]]]))
